export class ValueIs {
    Identifier: string;
    Value: any;
}
